import axios from "./api";
class RequirementService {
  getAll() {
    return axios.get(`/programRequirements`);
  }

  getByTraining(trainingId) {
    return axios.get(`/public/programRequirements/${trainingId}`);
  }
  get(id) {
    return axios.get(`/programRequirements/${id}`);
  }
  create(data) {
    return axios.post(`/programRequirements`, data);
  }
  update(id, data) {
    return axios.put(`/programRequirements/${id}`, data);
  }
  delete(id) {
    return axios.delete(`/programRequirements/${id}`);
  }
  // deleteAll() {
  //     return http.delete(`/requesting`);
  // }
  // findByTitle(titre) {
  //     return http.get(`/requesting?titre=${titre}`);
  // }
}

// eslint-disable-next-line import/no-anonymous-default-export
export default new RequirementService();
